import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';

import { IOrderTab } from './order.helpers';

interface ICPOrderParams {
    page: number;
    search: string;
    member: string;
    startDate: string | null;
    endDate: string | null;
    sortType: 'asc' | 'desc';
    sortField: string;
    limit: number;
    status: string;
    classification: string | null;
    shipper: string | null;
    consignee: string | null;
}

interface IOrderDashboardState {
    orderParams: ICPOrderParams;
    activeTab: string;
    tabsData: IOrderTab[];
    isFetchedTabs: boolean;
}

const initialOrderParams: ICPOrderParams = {
    page: 1,
    search: '',
    member: 'all',
    startDate: null,
    endDate: null,
    sortType: 'desc',
    sortField: 'createdAt',
    limit: 25,
    status: 'all',
    classification: null,
    shipper: null,
    consignee: null,
};

const initialState: IOrderDashboardState = {
    orderParams: initialOrderParams,
    activeTab: 'all',
    tabsData: [],
    isFetchedTabs: false,
};

export const OrderDashboardSlice = createSlice({
    name: 'OrderDashboard',
    initialState,
    reducers: {
        resetOrderDashboardState: () => initialState,
        setOrderParams: (state, { payload }) => {
            state.orderParams = { ...state.orderParams, ...payload };
        },
        setActiveTab: (state, { payload }) => {
            state.activeTab = payload;
        },
        setTabsData: (state, { payload }) => {
            state.tabsData = payload;
        },
        setIsFetched: (state, { payload }) => {
            state.isFetchedTabs = payload;
        },
    },
});

export default OrderDashboardSlice.reducer;

export const { resetOrderDashboardState, setOrderParams, setActiveTab, setTabsData, setIsFetched } = OrderDashboardSlice.actions;

export const orderParamsData = (state: RootState) => state.OrderDashboard.orderParams || initialOrderParams;

export const activeTabData = (state: RootState) => state.OrderDashboard.activeTab || 'all';

export const tabsDataData = (state: RootState) => state.OrderDashboard.tabsData || [];

export const isFetchedTabsData = (state: RootState) => state.OrderDashboard.isFetchedTabs;
